
import global from '@/utils/global'
import { defineComponent, nextTick } from 'vue'
import { getDispatchExamine, cancelDispatchExamine, getCompanyList, getInsureEnsurePlanListApi } from '@/api/long-insure'
import { BillDetailDto, BillDto } from '@/api/bill'
import batchPayroll from '@/components/batch-payroll.vue'
import { insureDispatchList, insureDispatchDelete, addDispatch } from '@/api/insure-deduction'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getInsureDailyFeeListApi, getInsureDailyFeeExportApi, getServeCompanyListApi, getInsureDailyStaffExportApi } from '@/api/insure-daily-ax'
import { formatter, downloadBlobFile } from '../utils/util'
import dayjs from 'dayjs'

export default defineComponent({
  name: 'InsureDailyPremiumRecord',
  components: {},
  data() {
    return {
      summaryData: {} as {
        totalRealPay: number
        totalInsuranceFee: number
        totalIncreaseInsuranceFee: number
        totalMembershipCardDeduction: number
      },
      formSearch: {
        projectTime: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
      },
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableData: [{}],
      totalValue1: 0 as number,
      totalValue2: 0 as number,
      totalValue3: 0 as number,
      totalValue4: 0 as number,
      selects: [] as string[], // 列表选中
      showExport: false,
      exportData: {
        billType: 1,
        serveCompanyId: [],
        date: dayjs().format('YYYY-MM'),
        ensurePlanId: undefined as string | undefined
      },
      serveCompanyOptions: [],
      ensurePlanList: [] as any[]
    }
  },
  created() {
    this.initTableList()
  },
  watch: {},
  methods: {
    async initTableList() {
      console.log(this.formSearch)
      const result = await getInsureDailyFeeListApi({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        queryStart: this.formSearch.projectTime[0],
        queryEnd: this.formSearch.projectTime[1]
      })
      this.total = result.totalCount
      this.tableData = result.list
      let value1 = 0
      let value2 = 0
      let value3 = 0
      let value4 = 0
      result.list.forEach((_) => {
        value1 = value1 + Number(_.realPay)
        value2 = value2 + Number(_.totalInsuranceFee)
        value3 = value3 + Number(_.increaseInsuranceFee)
        value4 = value4 + Number(_.membershipCardDeduction)
      })
      this.totalValue1 = Number(value1.toFixed(2))
      this.totalValue2 = Number(value2.toFixed(2))
      this.totalValue3 = Number(value3.toFixed(2))
      this.totalValue4 = Number(value4.toFixed(2))
    },
    onSearch() {
      this.pageNum = 1
      this.initTableList()
    },
    onReset() {
      this.formSearch = {
        projectTime: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
      }
      this.onSearch()
    },

    // 导出投保记录列表
    async onExport(start, end) {
      const res = await getInsureDailyStaffExportApi({
        queryStart: start ?? this.formSearch.projectTime[0],
        queryEnd: end ?? this.formSearch.projectTime[1],
        serveCompanyNameList: this.exportData.serveCompanyId,
        ensurePlanId: this.exportData.ensurePlanId || undefined
      })
      downloadBlobFile(res, `安心日保【${this.exportData.date}】人员账单`)
    },

    async onExportStaff(start, end) {
        const res = await getInsureDailyFeeExportApi({
            queryStart: start ?? this.formSearch.projectTime[0],
            queryEnd: end ?? this.formSearch.projectTime[1],
            ensurePlanId: this.exportData.ensurePlanId || undefined
        })
        downloadBlobFile(res, `安心日保【${this.exportData.date}】账单明细`)
    },
    handleSizeChange() {
      this.pageNum = 1
      this.initTableList()
    },
    handleSelectionChange(selects: { id: string }[]) {
      this.selects = selects.map((item) => item.id)
    },
    async onShowExport() {
        await Promise.all([
            this.onInitServeCompanyOptions(),
            this.onInitEnsurePlanList()
        ])
        this.showExport = true
    },
    async onInitEnsurePlanList() {
        if (this.ensurePlanList.length > 0) return
        const plans = await getInsureEnsurePlanListApi({ insureType: 8 })
        this.ensurePlanList = plans || []
    },
    async onInitServeCompanyOptions() {
        if (this.serveCompanyOptions.length > 0) return
        const options = await getServeCompanyListApi({
            insureType: 8
        })
        this.serveCompanyOptions = options
    },
    onSubmit() {
        const date = this.exportData.date ?? dayjs().format('YYYY-MM')
        const start = dayjs(date).startOf('month').format('YYYY-MM-DD')
        const end = dayjs(date).endOf('month').format('YYYY-MM-DD')
        if (this.exportData.billType === 1) {
            this.onExport(start, end)
        } else if(this.exportData.billType === 2) {
            // 导出账单
            this.onExportStaff(start, end)
        }
        this.onCancel()
    },
    onCancel() {
        this.$refs?.formRef?.resetFields()
        this.showExport = false
        this.exportData.billType = 1
        this.exportData.serveCompanyId = []
        this.exportData.date = dayjs().format('YYYY-MM')
        this.exportData.ensurePlanId = undefined
    }
  }
})
